var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Search"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 9",
    opacity: 0.01,
    width: 24,
    height: 24,
    fill: "#DD296E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7579 10.3792C17.7579 6.72382 14.7841 3.75 11.129 3.75L10.9338 3.75283C7.36847 3.85643 4.5 6.7891 4.5 10.3792C4.5 14.0342 7.47373 17.0078 11.129 17.0078L11.3956 17.0025C12.8994 16.9427 14.2757 16.3792 15.3608 15.4769L19.2046 19.3206L19.2805 19.3852C19.3869 19.4618 19.5123 19.5 19.6376 19.5L19.7313 19.4928C19.8555 19.4737 19.975 19.4163 20.0707 19.3206C20.3098 19.0815 20.3098 18.6938 20.0706 18.4547L16.2268 14.611L16.3825 14.4165C17.2444 13.2977 17.7579 11.8974 17.7579 10.3792ZM5.625 10.3792C5.625 7.34513 8.09506 4.875 11.129 4.875C14.1628 4.875 16.6329 7.34514 16.6329 10.3792C16.6329 11.6792 16.1788 12.9092 15.3618 13.8917L15.0352 14.2844L14.6415 14.6119C13.6591 15.4288 12.429 15.8828 11.129 15.8828C8.09503 15.8828 5.625 13.4129 5.625 10.3792Z",
    fill: "#DD296E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.89bcd61393760e80f904f544ad6c5f70.svg";
export { ForwardRef as ReactComponent };